<template>
  <div id="rodzaj-oferty">
    <T1HeadScripts rodzajstrony="rodzajofert" />
    <a-layout id="components-layout-demo-top" class="layout">
      <T1Header />
      <div class="container" id="t1content">
        <a-layout-content class="mb-48">
          <T1RodzajOfertyContent />
        </a-layout-content>
      </div>
      <!-- <T1Newsletter /> -->
      <T1Footer />
    </a-layout>
  </div>
</template>

<script>
import T1HeadScripts from "./components/T1HeadScripts";
import T1Header from "./components/T1Header/T1Header";
// import T1Newsletter from "./components/T1Newsletter";
import T1RodzajOfertyContent from "./components/T1RodzajOfertyContent";
import T1Footer from "./components/T1Footer/T1Footer";

export default {
  name: "rodzaj-oferty",
  data: () => ({}),
  methods: {
    getPageTitle() {
      return this.$route.name;
    }
  },
  components: {
    T1HeadScripts,
    T1Header,
    // T1Newsletter,
    T1Footer,
    T1RodzajOfertyContent
  }
};
</script>
